import { PlusOutlined } from '@ant-design/icons';
import './upload.less';
import { Modal, Upload } from 'antd';
import Cookies from 'js-cookie';
import React, { useState, useImperativeHandle, forwardRef } from 'react';
const getBase64 = (file) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});

const App = (props, ref) => {
	const [previewOpen, setPreviewOpen] = useState(false);
	const [previewImage, setPreviewImage] = useState('');
	const [previewTitle, setPreviewTitle] = useState('');
	const [fileList, setFileList] = useState([]);
	const handleCancel = () => setPreviewOpen(false);
	// 上传的地址
	const action = `${process.env.REACT_APP_BASEURL}/wapc/oss/uploadFileAndPage?contentType=1`;

	// 动态修改暴露的方法
	useImperativeHandle(
		ref,
		() => {
			// 进行过滤 只返回接口返回responseData里的值
			let urlList = (fileList || []).map((item) => {
				return item.response;
			});
			return {
				data: urlList,
				wipeData: wipeData
			};
		},
		[fileList]
	);
	const handlePreview = async (file) => {
		if (!file.url && !file.preview) {
			file.preview = await getBase64(file.originFileObj);
		}
		setPreviewImage(file.url || file.preview);
		setPreviewOpen(true);
		setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
	};
	const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
	// 设置身份token
	const Authorization = {
		Authorization: `Bearer ${Cookies.get('token')}`
	};
	function wipeData() {
		setFileList([]);
	}
	const uploadButton = (
		<div>
			<PlusOutlined />
			<div
				style={{
					marginTop: 8
				}}>
				请上传
			</div>
		</div>
	);
	return (
		<>
			<Upload
				action={action}
				headers={Authorization}
				listType="picture-card"
				fileList={fileList}
				onPreview={handlePreview}
				onChange={handleChange}>
				{fileList.length >= 3 ? null : uploadButton}
			</Upload>
			<Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
				<img
					alt="example"
					style={{
						width: '100%'
					}}
					src={previewImage}
				/>
			</Modal>
		</>
	);
};

export default forwardRef(App);
